/* Maison Atmosa — passerelle panier pour Dawn.
   Les formulaires atmosa qui ne sont pas des <product-form> de Dawn (packs, cartes de l'accueil,
   accessoires) ajoutent au panier en AJAX, mettent à jour le tiroir Dawn et l'ouvrent, sans recharger la page.
   Formulaires concernés : form[data-ma-ajax], form[data-ma-bundle], form.ma-bundle. */
(function () {
  'use strict';

  var SELECTOR = 'form[data-ma-ajax], form[data-ma-bundle], form.ma-bundle';

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function cartUrl(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  function labels(form) {
    var btn = form.querySelector('[type="submit"]');
    return {
      btn: btn,
      idle: btn ? (btn.getAttribute('data-ma-label') || btn.textContent.trim()) : '',
      busy: btn ? btn.getAttribute('data-ma-busy') : '',
      done: btn ? btn.getAttribute('data-ma-done') : ''
    };
  }

  function setState(form, state) {
    var l = labels(form);
    if (!l.btn) return;
    if (!l.btn.getAttribute('data-ma-label')) l.btn.setAttribute('data-ma-label', l.idle);
    l.btn.setAttribute('aria-busy', state === 'busy' ? 'true' : 'false');
    l.btn.disabled = state === 'busy';
    if (state === 'busy' && l.busy) l.btn.textContent = l.busy;
    else if (state === 'done' && l.done) {
      l.btn.textContent = l.done;
      setTimeout(function () { l.btn.textContent = l.btn.getAttribute('data-ma-label'); }, 1800);
    } else l.btn.textContent = l.btn.getAttribute('data-ma-label');
  }

  function showError(form, message) {
    var box = form.querySelector('[data-ma-error]');
    if (!box) {
      box = document.createElement('p');
      box.className = 'ma-form-error';
      box.setAttribute('data-ma-error', '');
      box.setAttribute('role', 'alert');
      form.appendChild(box);
    }
    box.textContent = message || '';
    box.hidden = !message;
  }

  function add(form) {
    if (form.__maBusy) return;
    form.__maBusy = true;
    setState(form, 'busy');
    showError(form, '');

    var d = drawer();
    var body = new FormData(form);
    if (d && typeof d.getSectionsToRender === 'function') {
      body.append('sections', d.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      body.append('sections_url', window.location.pathname);
    }

    var variantId = body.get('id') || body.get('items[0][id]');

    fetch(cartUrl('cart_add_url', '/cart/add'), {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          showError(form, data.description || data.message || '');
          return;
        }
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'atmosa-cart-bridge', productVariantId: variantId, cartData: data });
        }
        if (d) {
          if (typeof d.setActiveElement === 'function') d.setActiveElement(document.activeElement);
          d.renderContents(data);
          setState(form, 'done');
        } else {
          window.location = cartUrl('cart_url', '/cart');
        }
      })
      .catch(function () {
        showError(form, (window.cartStrings && window.cartStrings.error) || 'Une erreur est survenue. Réessayez.');
      })
      .then(function () {
        form.__maBusy = false;
        if (labels(form).btn && labels(form).btn.getAttribute('aria-busy') === 'true') setState(form, 'idle');
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!form || form.closest('product-form')) return;
    e.preventDefault();
    add(form);
  }, true);
})();
